export const SYMBOLS: string = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZÀÁÂÃÄÅ♪ÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ⛱⛵ÙÚÛÜÝÞßàáâãäå♩çèéê☯ìí☸ïðñòóôõö♭øùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđ☺ēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥ✈ħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐő♫♬ŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽž⛟⛳☮'
export const SYMBOLS_BASE_256 = SYMBOLS.substring(0, 256)

export const SYMBOLS_LENGTH: number = SYMBOLS.length

export const REGEX_HEX_INT_OR_EMPTY = /^-?[0-9a-fA-F]*$/
export const REGEX_HEX_INT_AND_NOT_EMPTY = /^-?[0-9a-fA-F]+$/
export const REGEX_DEC_INT_OR_EMPTY = /^-?[0-9]*$/
export const REGEX_DEC_INT_AND_NOT_EMPTY = /^-?[0-9]+$/

/**
 * Added to contract code to offset the sales package code to avoid collision with non sales-package contracts
 */
export const SALES_PACKAGE_OFFSET_DECIMAL = 1879048192 // 0x70000000
